import { FC, SVGProps } from 'react';

/** Standardized icon sizes. Pixel values live in {@link SIZE_PX}. */
export type IconSize = 's' | 'm' | 'l';

export const SIZE_PX: Record<IconSize, number> = {
  s: 16,
  m: 20,
  l: 24,
};

/**
 * Public props for every icon component.
 *
 * Preferred usage is the standardized `size` (`s`/`m`/`l`); color is inherited via
 * `currentColor`, so tint an icon by setting the surrounding element's CSS `color`.
 *
 * For one-off needs the underlying SVG props remain available as escape hatches:
 * - `color` — sets the icon color directly (resolves `currentColor`).
 * - `width` / `height` — explicit pixel size, overriding `size`.
 * - `style`, `className`, `onClick`, … — forwarded to the root `<svg>`.
 */
export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'ref'> {
  /** Standardized size. Defaults to `'m'`. Ignored when `width`/`height` are set. */
  size?: IconSize;
}

/** An SVG imported via `*.svg?react` (vite-plugin-svgr). */
export type SvgComponent = FC<SVGProps<SVGSVGElement>>;
